import { styled } from '@mui/material'

export const SubTitle = styled('h3')`
  margin: 0;
`
